import { LinearProgress, Stack, styled } from '@ethings/ui-toolkit';
import { Box, useTheme } from '@mui/material';
import { FC } from 'react';
import { ResponsiveText } from '../responsive-text';

interface Props {
  'data-testid'?: string;
  label?: string;
  subText?: string;
  value: number;
}

interface StyledLinearProgressProps {
  header: {
    progressColor: string;
  };
}

const StyledLinearProgress = styled(LinearProgress)<StyledLinearProgressProps>(({ header }) => ({
  color: header.progressColor,
}));

export const WizardHeader: FC<Props> = ({ label, subText, value, ...props }) => {
  const theme = useTheme();
  const { header } = theme.wizard;

  return (
    <Box data-testid={props['data-testid']} sx={{ backgroundColor: header.background }}>
      <Stack p="1rem">
        <ResponsiveText
          color={header.subText}
          variant="body2"
          responsiveOptions={{
            minFontSize: '0.75rem',
            maxFontSize: '0.875rem',
            textLengthThreshold: 30,
          }}
        >
          {subText}
        </ResponsiveText>
        <ResponsiveText
          color={header.contrastText}
          responsiveOptions={{
            minFontSize: '0.875rem',
            maxFontSize: '1rem',
            textLengthThreshold: 25,
          }}
        >
          {label}
        </ResponsiveText>
      </Stack>
      <StyledLinearProgress
        color="inherit"
        value={value}
        variant="determinate"
        header={header}
      />
    </Box>
  );
};
